import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { RegexService } from '@shared/services/regex.service';

import { WorkflowGuard } from '@shared/components/routeGuard/workflow-guard.service';
import { NotFoundComponent } from '@shared/components/not-found/not-found.component';

import { AccessibilityComponent } from './components/accessibility/accessibility.component';
import { AccountLockedComponent } from './components/account-locked/account-locked.component';
import { AccountRecoveryComponent } from './components/account-recovery/account-recovery.component';
import { ChallengeQuestionUnlockComponent } from './components/challenge-question-unlock/challenge-question-unlock.component';
import { ChallengeQuestionComponent } from './components/challenge-question/challenge-question.component';
import { ChangePasswordComponent } from './components/change-password/change-password.component';
import { ContactComponent } from './components/contact/contact.component';
import { ForgotAccountInfoComponent } from './components/forgot-account-info/forgot-account-info.component';
import { FullRecoveryComponent } from './components/full-recovery/full-recovery.component';
import { PivCardRecoveryComponent } from './components/piv-card-recovery/piv-card-recovery.component';
import { LayoutComponent } from './components/layout/layout.component';
import { LoginComponent } from './components/login/login.component';
import { MfaChallengeComponent } from './components/mfa-challenge/mfa-challenge.component';
import { MfaSetupComponent } from './components/mfa-setup/mfa-setup.component';
import { MfaComponent } from './components/mfa/mfa.component';
import { PasswordWarningComponent } from './components/password-warning/password-warning.component';
import { PrivacyPolicyComponent } from './components/privacy-policy/privacy-policy.component';
import { ResetChallengeQuestionComponent } from './components/reset-challenge-question/reset-challenge-question.component';
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';
import { SelectDestinationComponent } from './components/select-destination/select-destination.component';
import { TermsOfUseComponent } from './components/terms-of-use/terms-of-use.component';
import { LoginRedirectInterimComponent } from './components/login-redirect-interim/login-redirect-interim.component';
import { AdoLogoutComponent } from './components/ado-logout/ado-logout.component';
import { CheckSessionGuard } from './components/route-guards/check-session.guard';
import { RedirectService } from '@userProfile/services/redirect.service';

export const routes: Routes = [
  {
    path: '',
    resolve: [RegexService],
    children: [
      {
        path: '',
        component: LayoutComponent,
        children: [
          {
            path: '',
            pathMatch: 'full',
            component: LoginComponent,
            canActivate: [CheckSessionGuard],
            title: 'Login',
          },
          {
            path: 'account-recovery',
            component: AccountRecoveryComponent,
            title: 'Account Recovery',
          },
          {
            path: 'forgot-account-info',
            component: ForgotAccountInfoComponent,
            title: 'Forgot Account Info',
          },
          {
            path: 'full-recovery',
            component: FullRecoveryComponent,
            title: 'Full Recovery',
          },
          {
            path: 'piv-card-recovery',
            component: PivCardRecoveryComponent,
            title: 'PIV Card Recovery',
          },
          {
            path: 'reset-password',
            component: ResetPasswordComponent,
            title: 'Reset Password',
          },
          {
            path: 'challenge-question/:recoveryToken',
            component: ChallengeQuestionComponent,
            title: 'Reset Password - Challenge Question',
          },
          {
            path: 'challenge-question-unlock/:recoveryToken',
            component: ChallengeQuestionUnlockComponent,
            title: 'Unlock Account - Challenge Question',
          },
          {
            path: 'mfa-challenge',
            component: MfaChallengeComponent,
            title: 'Update MFA - Challenge Question',
          },
          {
            path: 'account-locked',
            component: AccountLockedComponent,
            title: 'Account Locked',
          },
          {
            path: 'change-password',
            component: ChangePasswordComponent,
            canActivate: [WorkflowGuard],
            title: 'Change Password',
          },
          {
            path: 'password-warning',
            component: PasswordWarningComponent,
            canActivate: [WorkflowGuard],
            title: 'Password Expires Soon Warning',
          },
          {
            path: 'authentication',
            component: MfaComponent,
            canActivate: [WorkflowGuard],
            title: 'MFA',
          },
          {
            path: 'login-redirect-interim',
            component: LoginRedirectInterimComponent,
            children: [
              {
                path: '**',
                component: LoginRedirectInterimComponent,
              },
            ],
          },
          {
            path: 'ado-logout',
            component: AdoLogoutComponent,
            title: 'ADO Logout',
          },
          {
            path: 'select-destination',
            component: SelectDestinationComponent,
            title: 'Account Setup Complete - Select Destination',
          },
          {
            path: 'reset-challenge-question/:recoveryToken',
            component: ResetChallengeQuestionComponent,
            title: 'Reset Challenge Question',
          },
        ],
      },
    ],
  },
  {
    path: 'login',
    component: NotFoundComponent,
    pathMatch: 'full',
    resolve: {
      redirect: RedirectService,
    },
    title: 'Login',
  },
  {
    path: 'authentication-setup',
    component: MfaSetupComponent,
    canActivate: [WorkflowGuard],
    title: 'MFA Setup',
  },
  {
    path: 'contact',
    component: ContactComponent,
    title: 'Contact',
  },
  {
    path: 'accessibility',
    component: AccessibilityComponent,
    title: 'Accessibility',
  },
  {
    path: 'privacy-policy',
    component: PrivacyPolicyComponent,
    title: 'Privacy Policy',
  },
  {
    path: 'terms-of-use',
    component: TermsOfUseComponent,
    title: 'Terms of Use',
  },
  {
    path: '**',
    redirectTo: 'not-found',
  },
  {
    path: 'not-found',
    component: NotFoundComponent,
    title: 'Not Found',
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class LoginRoutingModule {}
